export interface CreateTag
{
    tagName: string;
    tagsCategoriesId: number[];
    isActive: boolean;
}

export function CreateTagDefaultValues():CreateTag
{
    return {
      tagName: '',
      tagsCategoriesId: [],
      isActive: true
    }
}

export interface UpdateTag {
    id: string;
    tagName: string;
    tagCategoryId: number[];
    isActive: boolean;
}

export function UpdateTagDefaultValues():UpdateTag
{
    return {
      id: '',
      tagName: '',
      tagCategoryId: [],
      isActive: false
    }
}
